import Icon from 'components/core-v2/atoms/Icon'
import React from 'react'
import { formatCurrencyFull } from 'utilities/currency'

import { CURRENCY } from '../../../const'
import classes from './orders-accordion-summary.module.scss'
import { ConfirmedOrder, isBuyOrder, isConfirmedOrder, Order, OrderType } from './orders-types'

export interface OrderAccordionSummaryProps {
  order: Order
  type: OrderType
}

export const getTotal = (order: ConfirmedOrder) => {
  if (order.correction) return order.correction.amountToBeAllocated
  return isBuyOrder(order) ? order.value : Math.abs((order.shares * order.executionPrice) / 100)
}

export const OrderAccordionSummary = ({ order, type }: OrderAccordionSummaryProps) => {
  const orderDirection = isBuyOrder(order) ? 'Buy' : 'Sell'
  const date = new Date(order.createdDate).toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
  return (
    <div className={classes.root}>
      <span>
        <strong>{orderDirection}</strong> - order generated: {date}
      </span>
      {isConfirmedOrder(order, type) && (
        <span className={classes.amount}>
          Total amount: {formatCurrencyFull(getTotal(order), CURRENCY)}
        </span>
      )}
      {!isConfirmedOrder(order, type) && order.isConfirmationLate && !order.confirmation && (
        <span className={classes.late}>
          <Icon name="bell" size="default" />
          <span>Late Confirmations</span>
        </span>
      )}
    </div>
  )
}
